/**
 * Versión compuesta de `osm-group-mapping.ts` (generado) + el cableado
 * corregido en Modo Edición (guardado directo, ver overridesRuntime.ts —
 * hasta 2026-09-10 esto venía de `osm-group-mapping.overrides.ts`, pegado a
 * mano). El resto de la app importa de aquí, nunca directo de
 * `osm-group-mapping.ts` — así el archivo generado se puede regenerar sin
 * perder las correcciones.
 */
import type { OsmGroupAssignment } from './osm-group-mapping';
import { osmGroupMapping } from './osm-group-mapping';
import { osmGroupOverrides, excludedOsmIds } from './overridesRuntime';
import { applyOsmGroupOverrides } from './applyOsmGroupOverrides';
import { applyGroupWiringExclusions } from './applyGroupWiringExclusions';

export const osmGroupMappingResolved: OsmGroupAssignment[] = [];
export const osmGroupByOsmIdResolved: Record<number, OsmGroupAssignment> = {};
export const osmGroupByCabinetIdResolved: Record<number, OsmGroupAssignment[]> = {};

function replaceContents<T>(arr: T[], next: T[]): void {
  arr.length = 0;
  arr.push(...next);
}

function replaceRecord<T>(obj: Record<number, T>, next: Record<number, T>): void {
  for (const k of Object.keys(obj)) delete obj[k as unknown as number];
  Object.assign(obj, next);
}

/** Recalcula los 3 exports a partir de `osmGroupMapping` + el cableado
 * actual (`overridesRuntime.ts`). Se llama al cargar el módulo y de nuevo
 * cada vez que se guarda un cambio o al arrancar la app. */
export function recomputeOsmGroupMapping(): void {
  replaceContents(osmGroupMappingResolved, applyGroupWiringExclusions(
    applyOsmGroupOverrides(osmGroupMapping, osmGroupOverrides),
    excludedOsmIds,
  ));

  replaceRecord(osmGroupByOsmIdResolved,
    Object.fromEntries(osmGroupMappingResolved.map(m => [m.osmId, m])));

  replaceRecord(osmGroupByCabinetIdResolved,
    osmGroupMappingResolved.reduce((acc, m) => {
      (acc[m.cabinetId] ??= []).push(m);
      return acc;
    }, {} as Record<number, OsmGroupAssignment[]>));
}

recomputeOsmGroupMapping();
